import Vue from 'vue'
import VueRouter from 'vue-router'
import Intro from '../views/IntroPage.vue'
import store from '../store.js'
import { initializationComplete } from '../firebaseService'
import config from '../config.js'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Intro,
    meta: {
      unAuthAccess: true
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutPage.vue'),
    meta: {
      title: 'About - TPFLA',
      unAuthAccess: true
    }
  },
  {
    path: '/faq',
    name: 'FAQs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FAQ.vue'),
    meta: {
      title: 'FAQs - TPFLA',
      unAuthAccess: true
    }
  },
  {
    path: '/credits',
    name: 'Credits',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/CreditsPage.vue'),
    meta: {
      title: 'Credits - TPFLA',
      unAuthAccess: true
    }
  },
  {
    path: '/intro',
    name: 'Intro',
    component: () => import(/* webpackChunkName: "about" */ '../views/IntroPage.vue'),
    props: true,
    meta: {
      title: 'Introduction - TPFLA',
      unAuthAccess: true
    }
  },
  {
    path: '/reset',
    name: 'PasswordReset',
    component: () => import(/* webpackChunkName: "about" */ '../views/PasswordReset.vue'),
    props: true,
    meta: {
      title: 'Password Reset - TPFLA',
      unAuthAccess: true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "about" */ '../views/SettingsPage.vue'),
    props: true,
    meta: {
      title: 'Settings - TPFLA',
      unAuthAccess: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/LoginPage.vue'),
    props: true,
    meta: {
      title: 'Login - TPFLA',
      unAuthAccess: true
    }
  },
  {
    path: '/location/:episode?/:chapter?',
    name: 'Location',
    component: () => import(/* webpackChunkName: "about" */ '../views/LocationPage.vue'),
    meta: {
      title: 'Location - TPFLA',
      unAuthAccess: false
    },
    props: true
  },
  {
    path: '/chapter/:episode?/:chapter?',
    name: 'Chapter',
    component: () => import(/* webpackChunkName: "about" */ '../views/ChapterPage.vue'),
    meta: {
      title: 'Chapter - TPFLA',
      unAuthAccess: false
    },
    props: true
  },
  {
    path: '/story/:episode/:chapter/:story',
    name: 'Story',
    component: () => import(/* webpackChunkName: "about" */ '../views/StoryViewer.vue'),
    meta: {
      title: 'Story - TPFLA',
      unAuthAccess: false
    },
    props: true
  },
  {
    path: '/example',
    name: 'ExampleStory',
    component: () => import(/* webpackChunkName: "about" */ '../views/ExampleStoryViewer.vue'),
    meta: {
      title: 'Story - TPFLA',
      unAuthAccess: true
    },
    props: { example: true }
  },
  {
    path: '/contents/:page?',
    name: 'Contents',
    component: () => import(/* webpackChunkName: "about" */ '../components/ContentsComp.vue'),
    meta: {
      title: 'Full Contents - TPFLA',
      unAuthAccess: true
    },
    alias: [],
    props: true
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    let position = { x: 0, y: 0 }
    // Keep scroll position when using browser buttons
    if (savedPosition) {
      position = savedPosition
    }
    // Workaround for transitions scrolling to the top of the page
    // However, there are still some problems being fixed by the vue team
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(position)
      }, 500)
    })
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'These Pages Fall Like Ash'
  next()
}
)
const checkLoginRedirect = function (to) {
  if (!store.state.user && !store.state.progress.debug) {
    if (to.meta.unAuthAccess) {
      return false
    } else {
      return true
    }
  }
  return false
}
const checkParams = function (to) {
  if (parseInt(to.params.episode) > Object.keys(config.episodes).length) {
    return true
  } else if (parseInt(to.params.chapter) > config.episodes[parseInt(to.params.episode)].chapterCount) {
    return true
  } else if (parseInt(to.params.story) > config.episodes[parseInt(to.params.episode)].chapters[parseInt(to.params.chapter)].storyCount) {
    return true
  }
  return false
}
// If no user ID in local storage, force login
router.beforeEach((to, from, next) => {
  if (!initializationComplete) {
    const initializationInterval = setInterval(() => {
      if (initializationComplete) {
        clearInterval(initializationInterval)
        if (checkLoginRedirect(to)) {
          next({ name: 'Login' })
        } else {
          if (to.params.episode || to.params.chapter) {
            if (checkParams(to)) {
              console.log('high')
              next({ name: 'Intro' })
            } else {
              next()
            }
          } else {
            next()
          }
        }
      }
    },
    200)
  } else {
    if (checkLoginRedirect(to)) {
      next({ name: 'Login' })
    } else {
      if (to.params.episode || to.params.chapter || to.params.story) {
        if (checkParams(to)) {
          console.log('high')
          next({ name: 'Intro' })
        } else {
          next()
        }
      } else {
        next()
      }
    }
  }
})

export default router
